import { vec3 } from "gl-matrix";
import { Light } from "./Light";

export class LightManager {
    public ambientColor: vec3;
    public lights: Light[];

    constructor(ambientColor: vec3) {
        this.ambientColor = ambientColor;
        this.lights = [];
    }

    public getNearestLights(position: vec3): Light[] {

        // TODO: Use an octree to keep track of lights

        let distances = this.lights.map(light => {
            let deltaX = light.position[0] - position[0];
            let deltaY = light.position[1] - position[1];

            return {
                distance: deltaX * deltaX + deltaY * deltaY,
                light: light
            };
        });


        distances.sort((a, b) => {
            return a.distance - b.distance;
        });

        return distances.map(d => d.light);
    }
}
